import { Component, Input, OnInit } from '@angular/core';
import { Ng2DeviceService } from 'ng2-device-detector';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'

import { RestaurantService } from './restaurant.service';

import { Restaurant } from './restaurant';

import { MessageService }     from './message.service';


import 'rxjs/add/operator/switchMap';

@Component({

	selector: 'top-details',
	templateUrl: './top-details.component.html',
	styleUrls: ['./top-details.component.css']
})

export class TopDetailsComponent implements OnInit {
        deviceInfo = null;
        topbanner;
	constructor(
                private sanitizer: DomSanitizer,
		private m_restaurant_service: RestaurantService,
                private deviceService: Ng2DeviceService,
		private messageService: MessageService
  	) {}
	m_restaurant: Restaurant;
  

	ngOnInit(): void {
		this.getRestaurant();
                    
	}
 public sanitizeImage(image: string) {
            return this.sanitizer.bypassSecurityTrustStyle(`url(${image})`);
        }
	getRestaurant(): void {
        console.log("NAME "+ this.m_restaurant_service.name);
		this.m_restaurant_service.getRestaurant(this.m_restaurant_service.name).then(
			restaurant => {
				this.m_restaurant = restaurant;
                     this.m_restaurant.banner ='//media1.weeloy.com/upload/restaurant/'+this.m_restaurant_service.name+'/1440/'+this.m_restaurant.images[0];
                                this.topbanner = this.sanitizer.bypassSecurityTrustUrl("//media1.weeloy.com/upload/restaurant/"+this.m_restaurant_service.name+"/1440/"+this.m_restaurant.images[0]);
                                          this.deviceInfo = this.deviceService.getDeviceInfo();
   
			}
		);
	}

	clickedBookNow() {
    	console.log("TopDetailsComponent clickedBookNow")

    	this.messageService.sendMessage('Message from NavigationComponent to Book Component!');
  	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/top-details.component.ts